import React from 'react';
import { render } from 'react-dom';
import { EngagementMessages } from '@atlassiansox/engagekit-ts';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { JiraContextContainer } from '@atlassian/jira-context-container/src/JiraContextContainer.tsx';
import EngagementProvider from '@atlassian/jira-engagement-provider/src/index.tsx';
import { StrictMode } from '@atlassian/jira-react-strict-mode/src/StrictMode.tsx';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';

const throwError = (message: any) => {
	const error = new Error(message);
	log.safeErrorWithoutCustomerData('engagement-messages.entry', message, error);
	throw error;
};

const getContainer = () => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	let container = document.getElementById('engagement-messages');
	if (container == null) {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		container = document.createElement('div');
		container.id = 'engagement-messages';

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (document.body) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			document.body.appendChild(container);
		} else {
			throwError(
				'document.body was not found whilst trying to create the engagement-messages container',
			);
		}
	}
	return container;
};

const GetDom = () => {
	const { data: orgId } = useOrgId();
	return (
		<StrictMode>
			<JiraContextContainer>
				<EngagementProvider orgId={orgId}>
					<EngagementMessages />
				</EngagementProvider>
			</JiraContextContainer>
		</StrictMode>
	);
};

export const RenderEngagementMessages = () => render(<GetDom />, getContainer());

RenderEngagementMessages();
